import { BaseAPI } from '../base/service';
import { CourseType } from '../enums';
import { ExtraClass } from './dto';

export class ExtraClassAPI extends BaseAPI {
  private year = new Date().getFullYear();
  public getExtraClasses(type: CourseType): Promise<ExtraClass[]> {
    return this.api.get(`${type}/${this.year}/extra-classes/`);
  }
}
